<template>
    <div class="w-root">
        <div class="w-views">
            <div id="application-wrapper">
                <div class="content-wrapper">
                    <div class="conversation-screen">
                        <div id="conversation-group-scroll"  :class="{'disable-scroll':disableScroll}" class="conversation group" v-if="event">

                            <div class="header">
                                <i class="back" @click="goBack()"></i>

                                <div class="info group" v-if="event.type == 'bang'" @click="goToEvent"
                                    :class="{'online': event.isOnline, 'was-online': event.wasRecentlyOnline && !event.isOnline}">
                                    <div class="img" :style="{'background': `url(${event.photo_small}) no-repeat center / cover`}"></div>
                                    <div class="col">
                                        <div class="event-title">{{ event.title }}</div>
                                        <div class="date">{{ event.date | formatDate('day-date') }}</div>
                                    </div>
                                </div>

                                <div class="info group" v-else-if="event.type == 'club'" @click="goToEvent">
                                    <div class="img" :style="{'background': `url(${event.photo_small}) no-repeat center / cover`}"></div>
                                    <div class="col">
                                        <div class="event-title">{{ event.title }}</div>
                                    </div>
                                </div>
                            </div>

                            <vue2-gesture-custom :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
                                <GroupChatComponent  @changeScrollBarState="changeScrollBarState" chatMode="group" :eventId="parseInt(eventId)" v-if="event"></GroupChatComponent>
                            </vue2-gesture-custom>
                        </div>
                    </div>
                  <MediaWatcher ref="mediaWatcherClipBoardPhotoGroup" :items="[{id:1,'photo_orig' : clipboardFileUrl}]" type="photo" :fullscreen="false"></MediaWatcher>
                </div><!--content-wrapper-->
            </div><!--#application-wrapper-->
        </div><!--w-views-->
    </div><!--w-root-->
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import GroupChatComponent from '@chat/views/widgets/GroupChatComponent.vue';
    import eventsModule from '@events/module/store/type';
    import clubsModule from '@events/module/store/type';
    import "@buddy/lib/vue2-gesture-custom.js";
    import MediaWatcher from "../../../buddy/views/widgets/MediaWatcher.vue";

    export default {
        props: ['eventId'],
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-chat').default,
        ],
        data() {
            return {
              disableScroll : false,
              clipboardFileUrl: false,
              _backRoute: false
            }
        },
        computed: {
            ...mapState({
                blockedUsersIds: state => state.blockedUsersIds,
            }),
            ...mapGetters({
                membershipRequests:      eventsModule.getters.membershipRequests,
                membershipClubsRequests: clubsModule.getters.membershipClubsRequests,
            }),
            event(){
                return this.$store.getters.getEvent(this.eventId)
            }
        },
        watch: {
            blockedUsersIds: function(blockedUsersIds) {
                if (blockedUsersIds.includes(this.event?.user_id)) {
                    this.goTo('/chat')
                }
            }
        },
        components: {
          MediaWatcher,
            GroupChatComponent
        },
        methods: {

            changeScrollBarState(val){
              this.disableScroll = !val;
            },
            goBack(){
              app.prevMessageId = null;
              if(this._backRoute && this._backRoute !== '/'){
                this.$router.back()
              }else{
                this.goTo('/chat');
              }
            },
            goToEvent() {
                this.goTo((this.event?.type == 'club' ? '/club/' : '/bang/') + this.eventId);
            },
            handleGesture(str, e) {
                if (str == 'swipeRight') {
                    this.goTo('/chat')
                }
            },
        },
        beforeRouteEnter(to, from, next) {
          next(vm => {
            vm._backRoute = from.path
          })
        },
        mounted(){
            /*console.log('[ChatEventUser] mounted', {
                eventId: this.eventId
            })*/
            this.$store.dispatch(eventsModule.actions.events.loadInfo, {eventId: this.eventId, edit : 0})
            let self = this;
            app.$on('show-clipboard-photo-group', function(fileUrl){
              self.clipboardFileUrl = fileUrl;
              self.$refs.mediaWatcherClipBoardPhotoGroup.show(1);
            });
        },
        beforeDestroy() {
          app.$off('show-clipboard-photo');
        },
    }
</script>